<template>
    <div class="search-container wf-component wf-search">
        <div class="wf-search-container">
            <div class="wf-search-results" :class='{"wf-no-results": results.length == 0}'>
                <transition-group name="list" tag="ul" class="wf-list">
                    <li class="wf-list-item" :class='{"wf-active": currentPOI && poiitem.id == currentPOI.id}' v-for="poiitem in results" :key='poiitem.id'>
                        <div class="list-poi">
                            <label class="poi-name" v-html="poiitem.getName(language)"></label>
                            <button class="btn poi-floor" v-if="poiitem.getFloor()"><Icon name="floor"/><label>{{translate('floor', [poiitem.getFloor().getName(language)])}}</label></button>
                            <button class="btn btn-border" @click="onPOIClick(poiitem)"><Icon name="info"/><label data-translation-element="info">Info</label></button>
                            <button class="btn btn-border" @click="showPath(poiitem)"><Icon name="path"/><label data-translation-element="path">Teekond</label></button>
                        </div>
                    </li>
                </transition-group>
                <span class="wf-search-no-results-text" v-show="results.length == 0" data-translation-element="search-no-result-text"></span>
            </div>
            <div class="wf-search-input-container" v-show="showOutputField">
                <Icon name="search"/>
                <input id="wf-search-input" ref='searchInput' oncontextmenu="return false"/>
                <div class="icon close" @click="close($event)"><Icon name="close"/></div>
            </div>
            <div id="wf-keyboard-container" class="wf-keyboard">
            </div>
        </div>
    </div>
</template>
<script>
import OSK from 'on-screen-js-keyboard';

import { mapState } from 'vuex';

export default {
    computed: {//yahLogo
		...mapState('wf', ['language', 'landscape', 'portrait', 'reset']),
	},
    props: {
        showOutputField: {
            type: Boolean,
            default: true
        },
        currentPOI: {
			type: Object,
			default: null
		}
    },
    data () {
		return {
			results: [],
			poi: {},
			keyboard: false,
            limit: 4
		}
	},
    watch: {
		searchVisible (current) {
			if (current && this.$refs.searchInput) {
				this.$refs.searchInput.focus();
			}
		},
		reset () {
			this.resetValues();
		},
		language (lang) {
			if (this.keyboard) {
				this.keyboard.changeLayout(lang);
			}
		}
	},
    mounted () {
		this.keyboard = new OSK('wf-search-input', 'wf-keyboard-container');
		this.keyboard.on('change', (keyword) => {
			let results = this.$wayfinder.search.search(keyword);
            results.filter(p => {
                return p.getShowInMenu()
            });

			if (this.limit > 0) {
				results = results.slice(0, this.limit);
			}

			this.results = Object.freeze(Object.values(results));
			if (keyword.length > 1) {
				if (Object.values(this.results).length > 0) {
					this.$wayfinder.statistics.onSearch(keyword, "successful");
				}
				else {
					this.$wayfinder.statistics.onSearch(keyword, "unsuccessful");
				}
			}
		});

        this.keyboard.addLayout("et", {
            'name': "Estonian",
            'local_name': "Eesti",
            'lang': "et",
            'keys': {
                "default": [
                    ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "\u00FC", "\u00F5"],
                    ["a", "s", "d", "f", "g", "h", "j", "k", "l", "\u00F6", "\u00E4"],
                    ["z", "x", "c", "v", "b", "n", "m", ".", "&", {'key': "&#171;", 'action': ["backspace"], cls: "delete"}],
                    [{"key": " ", "cls": "key_spacebar"}]
                    ]
            }
        });

        this.keyboard.addLayout('en', {
            "name": "English",
            "keyboard":"US International",
            "local_name": "English",
            "lang": "en",
            "keys": {
                "default": [
                    ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
                    ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
                    ["z", "x", "c", "v", "b", "n", "m", ".", "&", {'key': "&#171;", 'action': ["backspace"], cls: "delete"}],
                    [{"key": " ", "cls": "key_spacebar"}]
                ]
            }
        });

		this.keyboard.changeLayout("et");
        this.$nextTick(() => {
            this.keyboard.setOutput("wf-search-input")
        })
	},
    methods: {
        close () {
            this.resetValues();
            this.$emit('close');
        },
        onPOIClick (poi) {
            this.$emit('onPOIClick', poi);
        },
        showPath (poi) {
            this.$emit('showPath', poi);
        },
        resetValues () {
			this.results = [];
			if (this.keyboard) {
				this.keyboard.changeLayout(this.language);
				this.keyboard.clearValue();
			}

			if (this.$refs.searchInput)
				this.$refs.searchInput.value = '';
		},
        setOutput (output) {
            console.log('search.setOutput', output);
			this.keyboard.setOutput(output);
		},
        translate (key, params) {
			return this.$wayfinder.translator.get(key, params)
		}
    }
}
</script>

<style lang="less">
    @import '../css/variables';
    .search-container {
        width: 100%;
        height: 100%;
        
        .icon-close {
            position: relative;
        }
    }

    .wf-search-container {
        height: 100%;
    }

    .wf-search-input-container {
        position: relative;
        input {
            padding-left: 7rem;
            padding-right: 7rem;
            outline: 0.2rem solid @active-color;
        }
        & > .icon {
            position: absolute;
            height: 1.8rem;
            
        }

        .icon-search {
            left: 4.8rem;
            --color1: @active-color;
            top: 2.7rem;
        }
    }
</style>